<!-- create j i s h e n g h u a -->
<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="单据编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入单据编号" v-model="queryParam.number"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="商品信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入编码、名称、规格、型号、颜色、扩展信息" v-model="queryParam.materialParam"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="单据日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker style="width:100%" v-model="queryParam.createTimeRange" format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onDateChange" @ok="onDateOk" />
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
                </a-col>
              </span>
              <template v-if="toggleSearchStatus">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="客户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择客户" showSearch optionFilterProp="children" v-model="queryParam.organId">
                      <a-select-option v-for="(item,index) in cusList" :key="index" :value="item.id">
                        {{ item.supplier }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="仓库名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="请选择仓库" showSearch optionFilterProp="children" v-model="queryParam.depotId">
                      <a-select-option v-for="(depot,index) in depotList" :key="index" :value="depot.id">
                        {{ depot.depotName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="操作员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择操作员" showSearch optionFilterProp="children" v-model="queryParam.creator">
                      <a-select-option v-for="(item,index) in userList" :key="index" :value="item.id">
                        {{ item.userName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="关联订单" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入关联订单" v-model="queryParam.linkNumber"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="结算账户" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择结算账户" showSearch optionFilterProp="children" v-model="queryParam.accountId">
                      <a-select-option v-for="(item,index) in accountList" :key="index" :value="item.id">
                        {{ item.name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="有无欠款" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择有无欠款" v-model="queryParam.hasDebt">
                      <a-select-option value="1">有欠款</a-select-option>
                      <a-select-option value="0">无欠款</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="单据状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select placeholder="选择单据状态" v-model="queryParam.status">
                      <a-select-option value="0">未审核</a-select-option>
                      <a-select-option value="1">已审核</a-select-option>
                      <a-select-option value="3">部分出库</a-select-option>
                      <a-select-option value="2">完成出库</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="单据备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入单据备注" v-model="queryParam.remark"></a-input>
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <a-button v-if="btnEnableList.indexOf(1)>-1" @click="myHandleAdd" type="primary" icon="plus">新增</a-button>
          <a-button v-if="btnEnableList.indexOf(1)>-1" icon="delete" @click="batchDel">删除</a-button>
          <a-button v-if="checkFlag && btnEnableList.indexOf(2)>-1" icon="check" @click="batchSetStatus(1)">审核</a-button>
          <a-button v-if="checkFlag && btnEnableList.indexOf(7)>-1" icon="stop" @click="batchSetStatus(0)">反审核</a-button>
          <a-button v-if="isShowExcel && btnEnableList.indexOf(3)>-1" icon="download" @click="handleExport">导出</a-button>
          <a-popover trigger="click" placement="right">
            <template slot="content">
              <a-checkbox-group @change="onColChange" v-model="settingDataIndex" :defaultValue="settingDataIndex">
                <a-row style="width: 500px">
                  <template v-for="(item,index) in defColumns">
                    <template>
                      <a-col :span="8">
                        <a-checkbox :value="item.dataIndex">
                          <j-ellipsis :value="item.title" :length="10"></j-ellipsis>
                        </a-checkbox>
                      </a-col>
                    </template>
                  </template>
                </a-row>
                <a-row style="padding-top: 10px;">
                  <a-col>
                    恢复默认列配置：<a-button @click="handleRestDefault" type="link" size="small">恢复默认</a-button>
                  </a-col>
                </a-row>
              </a-checkbox-group>
            </template>
            <a-button icon="setting">列设置</a-button>
          </a-popover>
          <a-tooltip placement="left" title="销售出库单可以由销售订单转过来，也可以单独创建。
          销售出库单据中的仓库列表只显示当前用户有权限的仓库。销售出库单可以使用多账户收款。
          勾选单据之后可以进行批量操作（删除、审核、反审核）" slot="action">
            <a-icon v-if="btnEnableList.indexOf(1)>-1" type="question-circle" style="font-size:20px;float:right;" />
          </a-tooltip>
        </div>
        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)" :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading" :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}" @change="handleTableChange">
            <span slot="action" slot-scope="text, record" v-if='record.status == "4"'>
              <a @click="continueHarvest(record)">继续采集</a>
            </span>
            <span slot="action" slot-scope="text, record" v-else-if='record.status == "5"'>
              <a @click="myHandleDetail(record, '销售出库', prefixNo)">查看</a>
              <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
              <a disabled="true">处理中</a>
            </span>
            <span slot="action" slot-scope="text, record" v-else>
              
               <a v-if="btnEnableList.indexOf(1)>-1 && record.status == '0'" @click="myHandleEdit(record)">编辑</a>
               <a-divider v-if="btnEnableList.indexOf(1)>-1 && record.status == '0'" type="vertical" />
<!--              <a v-if="btnEnableList.indexOf(1)>-1" @click="myHandleCopyAdd(record)">复制</a>-->
<!--              <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />-->
              <a v-if="btnEnableList.indexOf(1)>-1" @click="downloadExcel(record)">同行单</a>
              <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
              <a v-if="btnEnableList.indexOf(1)>-1" @click="synchronous(record)">同步追溯</a>
              <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />
              <a v-if="btnEnableList.indexOf(1)>-1" @click="outcode(record)">导出编码</a>
              <a-divider v-if="record.jgState == 1" type="vertical" />
              <a v-if="record.jgState == 1" @click="uploadManage(record)">上传监管</a>
              <!-- <a v-if="record.jgState == 1" @click="modifyHeader(record)">上传监管</a> -->
              <a-divider type="vertical" />
              <a @click="uploadTrace(record)">上传追溯</a>
              <a-divider type="vertical" />
              <a @click="continueHarvest(record)">继续采集</a>
<!--              <a-divider v-if="btnEnableList.indexOf(1)>-1" type="vertical" />-->
<!--              <a-popconfirm v-if="btnEnableList.indexOf(1)>-1" title="确定删除吗?" @confirm="() => myHandleDelete(record)">-->
<!--                <a>删除</a>-->
<!--              </a-popconfirm>-->
            </span>
            
            <template slot="customRenderDebt" slot-scope="value, record">
              <a-tooltip title="有收款单">
                <span style="color:green" v-if="value>0 && record.hasFinancialFlag">{{value}}</span>
              </a-tooltip>
              <a-tooltip title="暂未收款">
                <span style="color:red" v-if="value>0 && !record.hasFinancialFlag">{{value}}</span>
              </a-tooltip>
              <span v-if="value===0">{{value}}</span>
            </template>
            <template slot="number" slot-scope="text, record">
              <span class="elementButtonText" @click="openNumberLook(record)">{{ record.number }}</span>
            </template>
            <template slot="materialsList" slot-scope="text, record">
              <a-tooltip :title="record.materialsList">
                {{record.materialsList.substring(0,30)+(record.materialsList.length>30?'...':'')}}
              </a-tooltip>
            </template>

            <template slot="customRenderStatus" slot-scope="status">
              <a-tag v-if="status == '0'" color="red">未审核</a-tag>
              <a-tag v-if="status == '1'" color="green">已审核</a-tag>
              <a-tag v-if="status == '2'" color="cyan">完成出库</a-tag>
              <a-tag v-if="status == '3'" color="blue">部分出库</a-tag>
              <a-tag v-if="status == '4'" color="blue">采集中</a-tag>
              <a-tag v-if="status == '5'" color="blue">处理中</a-tag>
              <a-tag v-if="status == '9'" color="orange">审核中</a-tag>
            </template>
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <sale-out-modal ref="modalForm" @ok="modalFormOk" @close="modalFormClose"></sale-out-modal>
        <bill-detail ref="modalDetail" @ok="modalFormOk" @close="modalFormClose"></bill-detail>
        <bill-excel-iframe ref="billExcelIframe" @ok="modalFormOk" @close="modalFormClose"></bill-excel-iframe>
        <get-out-list-modal ref="getOutList" @ok="modalListOk" @close="modalListClose"></get-out-list-modal>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import GetOutListModal from './modules/getOutListModal'
import SaleOutModal from './modules/SaleOutModal'
import BillDetail from './dialog/BillDetail'
import BillExcelIframe from '@/components/tools/BillExcelIframe'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { BillListMixin } from './mixins/BillListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import JDate from '@/components/jeecg/JDate'
import { ACCESS_TOKEN,SCANNER_WEB_URL } from '@/store/mutation-types'
import { addMedicineDeopHead, modifyHeader, uploadEventTrace } from '@api/api'
import {getAction } from '@/api/manage'
import Vue from 'vue'
export default {
  name: 'SaleOutList',
  mixins: [JeecgListMixin, BillListMixin],
  components: {
    SaleOutModal,
    BillDetail,
    BillExcelIframe,
    JEllipsis,
    JDate,
    GetOutListModal
  },
  data() {
    return {
      // 查询条件
      queryParam: {
        number: '',
        materialParam: '',
        type: '出库',
        subType: '销售',
        organId: '',
        depotId: '',
        creator: '',
        linkNumber: '',
        accountId: '',
        hasDebt: '',
        status: '',
        remark: '',
      },
      prefixNo: 'XSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 默认索引
      defDataIndex: [
        'action',
        'organName',
        'number',
        'materialsList',
        'operTimeStr',
        'userName',
        'materialCount',
        'totalPrice',
        'totalTaxLastMoney',
        'needOutMoney',
        'changeAmount',
        'debt',
        'status',
      ],
      // 默认列
      defColumns: [
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 450,
          scopedSlots: { customRender: 'action' },
        },
        { title: '客户', dataIndex: 'organName', width: 120, ellipsis: true },
        { title: '客户Id', dataIndex: 'organId', width: 120, ellipsis: true },
        {
          title: '单据编号',
          dataIndex: 'number',
          width: 160,
          scopedSlots: { customRender: 'number' }
        },
        { title: '关联订单', dataIndex: 'linkNumber', width: 140 },
        { title: '商品信息', dataIndex: 'materialsList', width: 450,scopedSlots: { customRender: 'materialsList' } },
        { title: '单据日期', dataIndex: 'operTimeStr', width: 145 },
        { title: '操作员', dataIndex: 'userName', width: 80, ellipsis: true },
        { title: '数量', dataIndex: 'materialCount', width: 60 },
        { title: '金额合计', dataIndex: 'totalPrice', width: 80 },
        {
          title: '含税合计',
          dataIndex: 'totalTaxLastMoney',
          width: 80,
          customRender: function (text, record, index) {
            return (record.discountMoney + record.discountLastMoney).toFixed(2)
          },
        },
        {
          title: '优惠率',
          dataIndex: 'discount',
          width: 60,
          customRender: function (text, record, index) {
            return text ? text + '%' : ''
          },
        },
        { title: '收款优惠', dataIndex: 'discountMoney', width: 80 },
        { title: '其它费用', dataIndex: 'otherMoney', width: 80 },
        {
          title: '待收金额',
          dataIndex: 'needOutMoney',
          width: 80,
          customRender: function (text, record, index) {
            let needOutMoney = record.discountLastMoney + record.otherMoney - record.deposit
            return needOutMoney ? needOutMoney.toFixed(2) : 0
          },
        },
        { title: '结算账户', dataIndex: 'accountName', width: 80 },
        { title: '扣除订金', dataIndex: 'deposit', width: 80 },
        { title: '本次收款', dataIndex: 'changeAmount', width: 80 },
        { title: '本次欠款', dataIndex: 'debt', width: 80, scopedSlots: { customRender: 'customRenderDebt' } },
        { title: '销售人员', dataIndex: 'salesManStr', width: 120 },
        { title: '备注', dataIndex: 'remark', width: 200 },
        {
          title: '状态',
          dataIndex: 'status',
          width: 80,
          align: 'center',
          scopedSlots: { customRender: 'customRenderStatus' },
        },
      ],
      url: {
        list: '/depotHead/list',
        delete: '/depotHead/delete',
        deleteBatch: '/depotHead/deleteBatch',
        batchSetStatusUrl: '/depotHead/batchSetStatus',
      },
    }
  },
  computed: {},
  created() {
    this.initSystemConfig()
    this.initCustomer()
    this.getDepotData()
    this.initUser()
    this.initAccount()
  },
  
  methods: {
    //上传监管
    uploadManage(row){
      let that = this
      this.$confirm('是否确认上传监管?', '上传监管', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.loading = true
        getAction("/api/drugtrac/salesOutStoreUpload/",{headId:row.id}).then(res=>{
          if(res.code == 200){
            that.$message.success('上传成功')
          }else{
            that.$message.warning(res.message?res.message:'上传失败')
          }
          this.loading = false
          that.loadData(1)
        })
      }).catch((error) => {
        console.log(error)
        if(error!=='cancel'){
          that.$message.warning(error.message?error.message:"上传失败")
        }
      });
    },
    // modifyHeader(row){
    //   let that = this
    //   this.$confirm('是否确认上传监管?', '上传监管', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //   }).then(() => {
    //     modifyHeader({headId:row.id}).then(res=>{
    //       if(res.code == 200){
    //         that.$message.success('上传成功，共上传'+row.materialCount+'个0级码')
    //       }else{
    //         that.$message.warning('上传失败')
    //       }
    //       that.loadData(1)
    //     })
    //   }).catch(() => {});

    // },
    // 点击销售订单跳转页面
    openNumberLook(record){
      console.log(record,'record====================')
      this.$refs.getOutList.show(record)
    },
    // 继续采集
    continueHarvest(record){
      const token = Vue.ls.get(ACCESS_TOKEN)
      let billNo = record.number
      let organId = record.organId;
      console.log('跳转地址=====',SCANNER_WEB_URL)
      // 时间戳
      let timestamp = new Date().getTime();
      // window.open(
      //   `https://demon.fangzhima.com/port`+`/?token=${encodeURIComponent(token)}&billNo=${encodeURIComponent(billNo)}&organId=${encodeURIComponent(organId)}&timestamp=${encodeURIComponent(timestamp)}`
      // )
      window.open(
        `https://`+SCANNER_WEB_URL+`/?token=${encodeURIComponent(token)}&billNo=${encodeURIComponent(billNo)}&organId=${encodeURIComponent(organId)}&timestamp=${encodeURIComponent(timestamp)}`
      )
    },
    async uploadTrace(record){
        const res = await uploadEventTrace(record.id)
        if( res.code == 200 && res.success == true ){
          this.$message.success('上传成功')
        }else{
          this.$message.error(res.message)
        }
      }

  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
.elementButtonText {
  color: #1890ff;
  cursor: pointer;
}
</style>